import * as Sentry from "@sentry/react"

// NOTE: Check if we're in production
const isProduction = process.env.NODE_ENV === 'production'

// NOTE: Initialize Sentry
Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,

    // NOTE: Environment
    environment: isProduction ? 'production' : 'development',

    // NOTE: Integrations necessary
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: isProduction, // NOTE: false in development, true in production
            blockAllMedia: false,
        }),
    ],

    // NOTE: Performance Monitoring
    tracesSampleRate: isProduction ? 0.1 : 1, // NOTE: 10% in production, 100% in development

    // NOTE: Session Replay
    replaysSessionSampleRate: 0.1, // NOTE: 10% of normal sessions
    replaysOnErrorSampleRate: 1, // NOTE: 100% of sessions with error

    // NOTE: Setting this option to false will NOT send default PII data to Sentry
    sendDefaultPii: false,

    // NOTE: Debug mode (only in development)
    debug: !isProduction,
})
